<div class="dashboard-session-files" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="40px">
  <div class="dashboard-session-files__title">
    {{ selectedIntervention?.name }} &nbsp; {{ selectedIntervention?.code }}
  </div>
  <button mat-raised-button color="accent" (click)="goToMetricsDownloadSection()" fxFlexAlign="start">
    {{ 'Metrics download section' | uppercase }}
  </button>
  <div *ngIf="devices && !devices.length">There are no files for analysis.</div>
  <div
    fxLayout="column"
    fxLayoutAlign="space-around stretch"
    class="dashboard-session-files__items"
    *ngFor="let device of devices"
  >
    <mat-card fxLayout="row" fxLayoutAlign="space-between none">
      <div fxFlex="90">{{ device?.filename }}</div>
      <div fxFlex="10">
        <mat-icon
          [ngClass]="
            device?.validFile
              ? 'dashboard-session-files__items-status--active'
              : 'dashboard-session-files__items-status--blocked'
          "
        >
          {{ device?.validFile ? 'check_circle_outline' : 'block' }}
        </mat-icon>
      </div>
    </mat-card>
  </div>
</div>
